import { Injectable } from "@angular/core";
//import Keycloak from 'keycloak-js';
import { Subject } from 'rxjs';
import { environment } from "../../environments/environment";

/*
export function initializeAuth(authService: AuthService) {
  return () => authService.init();
}
*/

@Injectable()
export class AuthService {
  /*
  keycloak!: Keycloak;
  private onAuthSuccess$: Subject<any> = new Subject<any>();

  constructor() {
    this.keycloak = new Keycloak({
      url: environment.authServiceUrl,
      realm: environment.authServiceRealm,
      clientId: environment.authServiceClientId
    })
  }

  async login(redirectUri?: string) {
    if (this.keycloak.token &&
      this.keycloak.refreshToken &&
      this.keycloak.idToken
    ) {
      try {
        await this.keycloak.updateToken(5);
      } catch (e) {
        //Failed to refresh the token, or the session has expired
        console.error(e);
        this.keycloak.login({
          redirectUri
        });
      }
    } else {
      this.keycloak.login({
        redirectUri
      });
    }
  }

  async init() {
    this.createSubscriptions();
    const authToken = localStorage.getItem('auth-token');
    const refreshToken = localStorage.getItem('refresh-token');
    const idToken = localStorage.getItem('id-token');

    try {
      await this.keycloak.init({
        pkceMethod: 'S256',
        flow: 'standard',
        scope: 'microprofile-jwt email profile roles',
        token: authToken ?? undefined,
        idToken: idToken ?? undefined,
        refreshToken: refreshToken ?? undefined
      })
    } catch(error) {
      console.error(error)
    }
  }

  async getUserInfo() {
    if (this.keycloak.authenticated && !this.keycloak.userInfo) {
      return this.keycloak.loadUserInfo();
    }
    return this.keycloak.userInfo!;
  }

  async getAuthToken() {
    await this.keycloak.updateToken(5);
    return this.keycloak.token;
  }

  isAuthenticated() {
    console.log('authneticated: ' + this.keycloak.authenticated)
    return !!this.keycloak.authenticated;
  }

  hasRole(role: string | Array<string>) {
    const roles = this.keycloak.realmAccess?.roles ?? [];
    return Array.isArray(role)
    ? role.some((roleId) => roles.includes(roleId)) : roles.includes(role);
  }

  onAuthSuccess() {
    return this.onAuthSuccess$;
  }

  goToAccountPage() {
    window.location.href = this.keycloak.createAccountUrl();
  }

  logout() {
    localStorage.removeItem('auth-token');
    localStorage.removeItem('refresh-token');
    localStorage.removeItem('id-token');
    window.location.href = this.keycloak.createLogoutUrl(
      {
        redirectUri: window.location.origin + '/logged-out'
      });
  }
  getRealmRoles() {
    return this.keycloak.realmAccess?.roles;
  }

  private createSubscriptions() {
    this.keycloak.onAuthSuccess = () => this.onAuthSuccess$.next({});
    this.onAuthSuccess$.subscribe(() => {
      localStorage.setItem('auth-token', this.keycloak.token!);
      localStorage.setItem('refresh-token', this.keycloak.refreshToken!);
      localStorage.setItem('id-token', this.keycloak.idToken!);
    });
    this.keycloak.onAuthRefreshSuccess = () => {
      localStorage.setItem('auth-token', this.keycloak.token!);
    }

    this.keycloak.onTokenExpired = () => {
      this.keycloak.updateToken(5)
    }
  }
  */
}
